export const PAGE_TITLE = "mako n12 political match 2026";
export const SHARES_AND_SEO = {
  general: {
    title: 'המאץ׳ הפוליטי של N12',
    description: 'בחרו שתי מפלגות, ענו על 10 שאלות וגלו איזו מהן מתאימה יותר לעמדות שלכם',
    shares: {
      "title": "המאץ׳ הפוליטי של N12",
      "subtitle": "מי מהמפלגות מתאימה יותר לעמדות שלכם? בחרו שתי מפלגות, ענו על 10 שאלות וגלו",
      "imageUrl": "https://mako-political-match-content.rabbicdn.com/uploads/sharing/9a3a46f3f7260f7f4f4eec789043f517.jpg"
    }
  },
  resultsShares: {
    title: 'בדו קרב בין {partyA} ל-{partyB} יצא לי {highestScore}% התאמה ל-{highestMatchParty}',
    description: 'עשיתי את המאץ׳ הפוליטי של N12 וגיליתי איזו מפלגה מתאימה יותר לעמדות שלי. עכשיו תורכם'
  },
} 

export const REDUX_STORAGE_KEY = "__REDUX_STORAGE";
export const CAN_USE_DOM = !!(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);

export const SHARE_CONSTANTS = {
  TWITTER: "Twitter",
  FACEBOOK: "Facebook",
  MAIL: "E-mail",
  WHATS_APP: "whatsApp",
};

export const REG_EXP = {
  NUMBERS: /^[0-9\b]+$/,
  HEBREW_ONLY_LETTERS: /^[\u0590-\u05FF ,.'-]+$/i,
  HEBREW_WITH_NUMBERS: /^[\u0590-\u05FF 0-9 ,.'-]+$/,
  EMAIL: /[a-zA-Z@. 0-9]/,
};

export const DOMAIN_URL = "";

// const DAY = 60 * 60 * 24;
const MINUTE = 60 * 1;
const CACHE_VALUE = process.env.ENV === 'production' ? 1 * MINUTE : 10 * MINUTE;
export const CACHE_CONTROL_HEADER = `public, max-age=${CACHE_VALUE}, s-maxage=${CACHE_VALUE}`;
export const VARY_HEADER = 'origin, accept-encoding';

export const API_URL = 'https://mako-political-match-content.rabbicdn.com';